/* eslint-disable max-len */
import { FunctionComponent as F, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import PageHeadline from '../components/UI/Text/PageHeadline';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { useSelector } from 'react-redux';
import NewFundraiser from '../components/Fundraisers/NewFundraiser';
import { IState } from '../core/store/store';
import { IFundraisers, deleteFundraiser, getFundraisers } from '../core/http/fundraiser';
import ArticleText from '../components/UI/Text/ArticleText';
import { LOGIN } from '../core/router/paths';
import TextTooltip from '../components/UI/Tooltip/TextTooltip';



const Fundraisers: F = () =>
{
  const navigate = useNavigate();

  const user = useSelector((state: IState) => state.user);

  const [newFundraiserDialog, setNewFundraiserDialog] = useState(false);
  const [fundraisers, setFundraisers] = useState<IFundraisers[]>([]);

  function handleSubmitNewFundraiser(fundraiserId: number, title: string, recipientName: string, url: string)
  {
    if(!user.username || ! user.userId)
      return;

    const newFundraisersList = fundraisers.concat({ fundraiserId, title, recipientName, url, userId: user.userId });
    setFundraisers(newFundraisersList);
    setNewFundraiserDialog(false);
  }

  useEffect(() =>
  {
    getFundraisers()
      .then(data => setFundraisers(data || []));
  }, []);

  const handleRemove = async(fundraiserId: number) =>
  {
    deleteFundraiser(fundraiserId)
      .then(() => setFundraisers(fundraisers.filter(f => f.fundraiserId !== fundraiserId)));
  };

  function showRemoveIcon(fundraiserId: number)
  {
    return (
      <TextTooltip lines={["Delete fundraiser"]}>
        <RemoveCircleIcon
          onClick={() => handleRemove(fundraiserId)}
          style={{ paddingLeft: 8, verticalAlign: '-15%', cursor: 'pointer', color: 'red' }} />
      </TextTooltip>
    );
  }

  return (
    <Container>
      <Stack justifyContent='center' alignItems='center' spacing={2}>

        <PageHeadline>Fundraisers</PageHeadline>

        <Box sx={{ width: 650 }}>
          <Box>
            {fundraisers.map(item =>
              <Box key={item.fundraiserId}>
                <ArticleText>
                  <Link
                    sx={{ display: 'inline-flex' }}
                    target='_blank'
                    rel='noreferrer noopener'
                    href={item.url}>
                    <li>{item.recipientName}</li>
                  </Link>
                  {item.userId === user.userId ? showRemoveIcon(item.fundraiserId) : <></>}
                </ArticleText>
              </Box>
            )}
          </Box>
          <br/>
          <ArticleText>
            Please
            <Link
              component='button'
              sx={{pl: 1, fontSize: 17, verticalAlign: 'baseline'}}
              underline='none'
              variant='body1'
              onClick={() =>
              {
                if(user.username)
                  setNewFundraiserDialog(true);
                else
                  navigate(LOGIN);
              }}>
              {"add"}
            </Link>
            {" any I have missed – I’m sure I’m forgetting some! ❤"}
            <br/>
            <br/>
            {"And if you'd like to make a one-off donation to Protoplan's running costs, click "}
            <Link underline='none' target='_blank' rel='noreferrer noopener' href='https://www.paypal.com/donate/?business=9B653LR2MPBPS&no_recurring=0&item_name=for+server+fees+and+WBBJ+%F0%9F%8D%B7%F0%9F%A5%B0%F0%9F%98%84&currency_code=GBP'>here</Link>.
            Thank you! 🙏
          </ArticleText>
        </Box>

      </Stack>

      {newFundraiserDialog ? <NewFundraiser
        fundraisers={fundraisers}
        handleSubmit={handleSubmitNewFundraiser}
        closeDialog={() => setNewFundraiserDialog(false)}/> : <></>}

    </Container>);
};

export default Fundraisers;
